// extracted by mini-css-extract-plugin
export var blue = "_1o-f";
export var brand = "_1o-b";
export var darkGrey = "_1o-e";
export var disabled = "_1o-4";
export var disabledSubtle = "_1o-5";
export var error = "_1o-6";
export var green = "_1o-g";
export var grey = "_1o-d";
export var icon = "_1o-0";
export var inherit = "_1o-a";
export var lightGrey = "_1o-c";
export var orange = "_1o-i";
export var pink = "_1o-k";
export var primary = "_1o-1";
export var purple = "_1o-l";
export var red = "_1o-j";
export var secondary = "_1o-2";
export var success = "_1o-9";
export var tertiary = "_1o-3";
export var warning = "_1o-7";
export var warningSecondary = "_1o-8";
export var white = "_1o-m";
export var yellow = "_1o-h";